var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_855_2767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.125 5.25V2.625C6.125 2.39294 6.21719 2.17038 6.38128 2.00628C6.54538 1.84219 6.76794 1.75 7 1.75H17.5C17.7321 1.75 17.9546 1.84219 18.1187 2.00628C18.2828 2.17038 18.375 2.39294 18.375 2.625V14.875C18.375 15.1071 18.2828 15.3296 18.1187 15.4937C17.9546 15.6578 17.7321 15.75 17.5 15.75H14.875V18.375C14.875 18.858 14.4812 19.25 13.9939 19.25H3.50612C3.39074 19.2507 3.27635 19.2286 3.16953 19.1849C3.06272 19.1413 2.96558 19.0769 2.8837 18.9956C2.80182 18.9143 2.73682 18.8176 2.69242 18.7111C2.64803 18.6046 2.62511 18.4904 2.625 18.375L2.62763 6.125C2.62763 5.642 3.02138 5.25 3.50875 5.25H6.125ZM4.37762 7L4.375 17.5H13.125V7H4.37762ZM7.875 5.25H14.875V14H16.625V3.5H7.875V5.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_855_2767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c6feee79f3cffd82db8e507510b60ffe.svg";
export { ForwardRef as ReactComponent };